import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const PlotsList = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/List.vue');
const PlotCreate = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/Create.vue');
const PlotEdit = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/Edit.vue');
const PlotShow = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/Show.vue');
const PlotFollowUp = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/FollowUp.vue');
const PlotsRainsList = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/Rain/List.vue');
const PlotPermissions = () => import(/* webpackChunkName: "plots" */ '@/views/PlotPermissions/Show.vue');
const PlotsListMap = () => import(/* webpackChunkName: "plots" */ '@/views/Plots/ListMap.vue');

let plotsPages = {
  path: '/plots',
  redirect: '/plots',
  component: DashboardLayout,
  name: 'Plots',
  meta: {
    title: 'Lotes',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'PlotsList',
      meta: {
        title: 'Listado',
        auth: ['plots.index'],
      },
      component: PlotsList,
    },
    {
      path: 'create',
      name: 'PlotCreate',
      meta: {
        title: 'Nuevo',
        auth: ['plots.store'],
      },
      component: PlotCreate,
    },
    {
      path: 'map',
      name: 'PlotsListMap',
      meta: {
        title: 'Ubicacaciones de lotes',
        auth: ['plots.index'],
      },
      component: PlotsListMap,
    },
    {
      path: ':id/edit',
      name: 'PlotEdit',
      meta: {
        title: 'Editar',
        auth: ['plots.update'],
      },
      component: PlotEdit,
    },
    {
      path: ':id',
      name: 'PlotShow',
      meta: {
        title: 'Detalle',
        auth: ['plots.show'],
      },
      component: PlotShow,
    },
    {
      path: ':id/rainfall',
      name: 'PlotsRainsList',
      meta: {
        title: 'Precipitaciones',
        auth: ['rain_measures.index'],
      },
      component: PlotsRainsList,
    },
    {
      path: ':id/follow-up',
      name: 'PlotFollowUp',
      meta: {
        title: 'Seguimiento',
        auth: ['plots.update'],
      },
      component: PlotFollowUp,
    },
    {
      path: ':id/permissions',
      name: 'PlotPermissions',
      meta: {
        title: 'Permisos',
        auth: ['plot_permissions.index'],
      },
      component: PlotPermissions,
    },
  ],
};

export default plotsPages;
